import React from "react";
import "./Opinions.css";
import CustomerReview from "../../../components/landing/CustomerReview";

import avatar1 from "../../../../new_images/Landing/Mix/Mix_inicio_testigo1_opinion.png";
import avatar2 from "../../../../new_images/Landing/Mix/Mix_inicio_testigo2_opinion.png";
import avatar3 from "../../../../new_images/Landing/Mix/Mix_inicio_testigo3_opinion.png";

class Opinions extends React.Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="col-lg-9 col-md-11 col-sm-11">
            <p className="title">¿Qué opinan nuestros clientes?</p>

            <p className="subtitle">
              Hemos preguntado a nuestros usuarios que opinan de la experiencia
              que ofrece el servicio de carpool de Tovo
            </p>
          </div>
          
            <div className="row">
              <div id="opinion_1" className="col-lg-4">
                <CustomerReview
                  avatar={avatar1}
                  name="Tomas López"
                  review="“Llevo más de 7 meses usando los viajes compartidos de Tovo. Ofrece los mejores precios y experiencias de viaje que he visto. ¡Un servicio sin igual!”"
                />
              </div>

              <div id="opinion_2" className="col-lg-4">
                <CustomerReview
                  avatar={avatar2}
                  name="Andrés Cardenas"
                  review="“Sin ninguna duda Tovo es un servicio que no debes perderte. La experiencia durante cada viaje es excelente, de lo mejor en viajes compartidos. ”"
                />
              </div>

              <div id="opinion_3" className="col-lg-4">
                <CustomerReview
                  avatar={avatar3}
                  name="Pedro Góngora"
                  review="“Tovo ofrece las mejores experiencias de viaje si buscas rutas compartidas. El servicio es de calidad, los conductores son muy amables y puntuales.”"
                />
              </div>
            </div>
          
        </div>
      </section>
    );
  }
}

export default Opinions;
